import { useEffect, useState } from 'react';
import { ApiWrapper } from './models/ApiWrapper';
import { Config } from './models/Config';

const useConfig = () => {
  const [config, setConfig] = useState<Config | null>(null);

  // useEffect(() => {
  //   async function getConfig() {
  //     const response = await fetch(`/api/GlobalInfo`, { credentials: 'same-origin' });
  //     return (await response.json()) as ApiWrapper<Config>;
  //   }

  //   getConfig().then(res => setConfig(res.Data));
  // }, []);

  if(config == null)
  {
   setConfig({});
  }

  return config;
};

export default useConfig;

